export const TipoEscaninho = {
    // TODOS: { id: 0, descricao: "Todos os escaninhos" },
    GERENCIAL: { id: 1, descricao: "Escaninho do Gabinete" },
    USUARIO: { id: 2, descricao: "Escaninho do Usuário" },
    VISTOS: { id: 3, descricao: "Escaninho de Vistos" },
    JULGAMENTO: { id: 4, descricao: "Escaninho de Julgamento" },
    PETICOES: { id: 5, descricao: "Escaninho de Petições" },
    REDATOR_DESIGNADO: { id: 6, descricao: "Escaninho de Redator Designado" },
    JUSTIFICATIVA_VOTO_VENCIDO: { id: 7, descricao: "Escaninho de Justificativa de Votos Vencidos" },
    PAUTA: { id: 8, descricao: "Escaninho de Pauta" },
} as const;

export type TipoEscaninhoEnum = typeof TipoEscaninho[keyof typeof TipoEscaninho];
